<template>
  <div>
    <div
      v-for="(item, index) in items"
      v-bind:key="index"
      class="item-description"
    >
      <div v-if="currentItem === index" class="container-fluid itemnumber">
        <div class="row">
          <div class="col-12">
            <h5>{{ $t("Set.Overview.itemnumber") }}</h5>
          </div>
          <div class="col-8">
            <p>{{ item.itemnumber }}</p>
          </div>
          <div class="col-4 text-end">
            <CopyIcon
              :textToCopy="item.itemnumber"
              iconWidth="3"
              feedback="icon"
            />
          </div>
        </div>
      </div>
      <div v-if="currentItem === index" class="container-fluid price">
        <div class="row">
          <div class="col-12">
            <h5 class="title-price">
              {{ $t("Set.Item.Description.price.title") }}
            </h5>
          </div>
        </div>
        <div v-if="isCurrentItemDiamond === false" class="row">
          <div class="col-6">
            {{ $t("Common.jewelleryType." + item.description.jewelleryType) }}:
          </div>
          <div class="col-6 text-end">
            <template
              v-if="
                (!item.price.discount || item.price.discount == 0) &&
                !$parent['isDiamondGroupPline'](
                  parseInt(item.description['plineId'])
                ) &&
                !$parent['isTotalPriceProduct'](
                  parseInt(item.description['brandId']),
                  parseInt(item.description['plineId'])
                )
              "
            >
              {{ $n(item.price.ring, "currency") }}
            </template>
            <template v-else-if="item.price.discount && item.price.discount > 0">
              {{ $n(item.price.totalOriginal - item.price.discount, "currency") }}
            </template>
            <template v-else>{{
              $n(item.price.ring + item.price.stone, "currency")
            }}</template>
          </div>
        </div>
        <div
          class="row"
          v-if="
            !item.price.totalPrice &&
            isCurrentItemDiamond === false &&
            (!item.price.discount || item.price.discount == 0) &&
            !$parent['isDiamondGroupPline'](
              parseInt(item.description['plineId'])
            ) &&
            !$parent['isTotalPriceProduct'](
              parseInt(item.description['brandId']),
              parseInt(item.description['plineId'])
            )
          "
        >
          <div class="col-6">{{ $t("Set.Item.Description.price.stone") }}:</div>
          <div class="col-6 text-end">
            {{ $n(item.price.stone, "currency") }}
          </div>
        </div>
        <div v-if="isCurrentItemDiamond === false" class="row">
          <div class="col-6">
            {{ $t("Set.Item.Description.price.engraving") }}:
          </div>
          <div class="col-6 text-end">
            {{ $n(item.price.engraving, "currency") }}
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <span
              class="price-discount"
              v-if="
                (item.price.discount && item.price.discount > 0) ||
                (campaigns.priceDrop === 'yes' &&
                  item.description.jewelleryType < 1)
              "
            >
              <strong>{{ $t("Set.Item.Description.price.special") }}</strong>
            </span>
            <span v-else>{{ $t("Set.Item.Description.price.total") }}</span>
          </div>
          <div class="col-6 text-end">
            <template
              v-if="
                (item.price.discount && item.price.discount > 0) ||
                (campaigns.priceDrop === 'yes' &&
                  item.description.jewelleryType < 1)
              "
            >
              <strong class="price-discount">{{
                $n(item.price.total + item.price.engraving, "currency")
              }}</strong>
            </template>
            <template v-else>
              <span>{{
                $n(item.price.total + item.price.engraving, "currency")
              }}</span>
            </template>
          </div>
        </div>
        <div class="row" v-if="isCampaignWeddingRings">
          <div class="col-12 campaign-info text-end">
            {{ $t("Set.Overview.campaign.discount") }}*
          </div>
        </div>
      </div>
      <div
        v-if="
          currentItem === index &&
          (item.description.possibleVariations || isCurrentItemDiamond)
        "
        class="container-fluid desc"
      >
        <div
          class="row"
          v-if="
            item.description.possibleVariations.ringsize || isCurrentItemDiamond
          "
        >
          <div class="col-4">
            <h5>{{ $t("Set.Item.Description.name.title") }}</h5>
          </div>
          <div class="col-8">
            <input
              type="text"
              :value="item.name"
              :placeholder="
                $t('Set.Item.Description.name.placeholder') + ' ' + (index + 1)
              "
              class="form-control"
              maxlength="20"
              @change="changeItemName($event.target.value)"
            />
          </div>
        </div>
        <div class="row" v-if="item.description.possibleVariations.ringsize">
          <div class="col-8">
            <h5>{{ $t("Set.Item.Description.ringsize") }}</h5>
          </div>
          <div class="col-4">
            <input
              type="number"
              :step="sizeStep"
              :min="minSize"
              :max="maxSize"
              v-model="item.size"
              @change="changeItemSize($event)"
              class="form-control"
            />
          </div>
          <div
            class="col-12 text-danger"
            v-if="
              item.size > overSize &&
              item.size >= minSize &&
              item.size <= maxSize
            "
          >
            <br />
            <p>{{ $t("Set.Item.Description.size.oversize.alert.text") }}</p>
            <a
              href="/online-bestellen/?showCostsForLargeSizes=true"
              target="_blank"
              >{{ $t("Set.Item.Description.size.oversize.link") }} &gt;</a
            >
          </div>
        </div>
        <div
          class="row"
          v-if="item.description.model && item.description.model !== ''"
        >
          <div class="col-12">
            <h5>{{ $t("Set.Overview.item.name") }}:</h5>
          </div>
          <div class="col-12">
            <p>{{ item.description.model }}</p>
          </div>
        </div>
        <div
          class="row"
          v-if="item.description.possibleVariations.engraving"
          @click="configure('engraving')"
        >
          <div class="col-10">
            <h5 class="headline-engraving">
              {{ $t("Set.Item.Description.engraving.title") }}
            </h5>
            <p v-if="item.engraving.inside.font > 0">
              <b v-if="item.engraving.inside.text != ''"
                >{{ item.engraving.inside.text }}<br
              /></b>
              {{ $t("Set.Item.Description.engraving.inside") }}:
              {{ getEngravingText(item.engraving.inside.font) }}
              <br />
            </p>
            <p v-if="item.engraving.outside.font > 0">
              <b v-if="item.engraving.outside.text != ''"
                >{{ item.engraving.outside.text }}<br
              /></b>
              {{ $t("Set.Item.Description.engraving.outside") }}:
              {{ getEngravingText(item.engraving.outside.font) }}
              <br />
            </p>
            <p
              v-if="
                item.engraving.inside.text == '' &&
                item.engraving.outside.text == ''
              "
            >
              {{ $t("Set.Item.Description.engraving.noEngraving") }}
            </p>
          </div>
          <div class="col-2 text-end">
            <img :src="appUrl + '/img/icons/edit.svg'" class="icon" />
          </div>
        </div>
        <div
          class="row"
          v-if="item.description.possibleVariations.profiles"
          @click="configure('profiles')"
        >
          <div class="col-10">
            <h5>{{ $t("Set.Item.Description.profile") }}</h5>
            <p>{{ item.description.profile }}</p>
          </div>
          <div class="col-2 text-end">
            <img :src="appUrl + '/img/icons/edit.svg'" class="icon" />
          </div>
        </div>
        <div
          class="row"
          v-if="
            item.description.possibleVariations.jewellery &&
            item.description.possibleVariations.jewellery.necklace
          "
          @click="configure('jewellery/necklace')"
        >
          <div class="col-10">
            <h5>{{ $t("Set.Item.Description.necklace") }}</h5>
            <p>{{ item.description.model }}</p>
          </div>
          <div class="col-2 text-end">
            <img :src="appUrl + '/img/icons/edit.svg'" class="icon" />
          </div>
        </div>
        <div
          class="row"
          v-if="item.description.possibleVariations.shutters"
          @click="configure('shutters')"
        >
          <div class="col-10">
            <h5>{{ $t("Set.Item.Description.shutter") }}</h5>
            <p>{{ item.description.profile }}</p>
          </div>
          <div class="col-2 text-end">
            <img :src="appUrl + '/img/icons/edit.svg'" class="icon" />
          </div>
        </div>
        <div
          class="row"
          v-if="
            (item.description.width != '0' || item.description.height != '0') &&
            item.description.jewelleryType < 1
          "
          @click="configure('widths')"
        >
          <div class="col-5">
            <h5>{{ $t("Set.Item.Description.width") }}</h5>
            <p>{{ item.description.width }}mm</p>
          </div>
          <div class="col-5">
            <h5>{{ $t("Set.Item.Description.height") }}</h5>
            <p>{{ item.description.height }}mm</p>
          </div>
          <div
            class="col-2 text-end"
            v-if="item.description.possibleVariations.widths"
          >
            <img :src="appUrl + '/img/icons/edit.svg'" class="icon" />
          </div>
        </div>
        <div
          class="row"
          v-if="item.description.possibleVariations.lengths"
          @click="configure('lengths')"
        >
          <div class="col-10">
            <h5>{{ $t("Set.Item.Description.length") }}</h5>
            <p>{{ item.description.length }} cm</p>
          </div>
          <div class="col-2 text-end">
            <img :src="appUrl + '/img/icons/edit.svg'" class="icon" />
          </div>
        </div>
        <div
          class="row"
          v-if="item.description.possibleVariations.chainWidths"
          @click="configure('chainWidths')"
        >
          <div class="col-10">
            <h5>{{ $t("Set.Item.Description.width") }}</h5>
            <p>{{ item.description.width }} mm</p>
          </div>
          <div class="col-2 text-end">
            <img :src="appUrl + '/img/icons/edit.svg'" class="icon" />
          </div>
        </div>
        <div
          class="row"
          v-if="item.description.possibleVariations.allocations"
          @click="configure('allocations')"
        >
          <div class="col-10">
            <h5>{{ $t("Set.Item.Description.allocations") }}</h5>
            <p>
              {{
                $tc(
                  "Common.itemAllocation." + item.description.ringType,
                  item.description.numberOfDiscs
                )
              }}
            </p>
          </div>
          <div class="col-2 text-end">
            <img :src="appUrl + '/img/icons/edit.svg'" class="icon" />
          </div>
        </div>
        <div
          class="row"
          v-if="item.description.possibleVariations.colors"
          @click="configure('colors')"
        >
          <div class="col-10">
            <h5>{{ $t("Set.Item.Description.color") }}</h5>
            <p>{{ item.description.color }}</p>
          </div>
          <div class="col-2 text-end">
            <img :src="appUrl + '/img/icons/edit.svg'" class="icon" />
          </div>
        </div>
        <div
          class="row"
          v-if="item.description.possibleVariations.metals"
          @click="configure('metals')"
        >
          <div class="col-10">
            <h5>{{ $t("Set.Item.Description.alloy") }}</h5>
            <p>{{ item.description.metal }}</p>
          </div>
          <div
            class="col-2 text-end"
            v-if="item.description.possibleVariations.metals"
          >
            <img :src="appUrl + '/img/icons/edit.svg'" class="icon" />
          </div>
        </div>
        <div
          class="row"
          v-if="item.description.possibleVariations.finishes"
          @click="configure('finishes')"
        >
          <div class="col-10">
            <h5>{{ $t("Set.Item.Description.finish") }}</h5>
            <p>{{ item.description.finish }}</p>
          </div>
          <div class="col-2 text-end">
            <img :src="appUrl + '/img/icons/edit.svg'" class="icon" />
          </div>
        </div>
        <div
          class="row"
          v-if="
            (item.description.possibleVariations.grooves ||
              (item.description.grooves != '' &&
                item.description.grooves != '-')) &&
            item.description.jewelleryType != 5
          "
          @click="configure('grooves')"
        >
          <div class="col-10">
            <h5>{{ $t("Set.Item.Description.grooves.title") }}</h5>
            <p
              v-if="
                item.description.grooves != '' &&
                item.description.grooves != '-'
              "
            >
              {{ item.description.grooves }}
            </p>
            <p v-else>{{ $t("Set.Item.Description.grooves.empty") }}</p>
          </div>
          <div class="col-2 text-end">
            <img
              v-if="item.description.possibleVariations.grooves"
              :src="appUrl + '/img/icons/edit.svg'"
              class="icon"
            />
          </div>
        </div>
        <div
          class="row"
          v-if="item.description.possibleVariations.addons"
          @click="configure('addons')"
        >
          <div class="col-10">
            <h5>{{ $t("Set.Item.Description.addons.title") }}</h5>
            <p v-if="item.description.addons != ''">
              {{ item.description.addons }}
            </p>
            <p v-else>{{ $t("Set.Item.Description.addons.empty") }}</p>
          </div>
          <div class="col-2 text-end">
            <img :src="appUrl + '/img/icons/edit.svg'" class="icon" />
          </div>
        </div>
        <div
          class="row"
          v-if="
            item.description.possibleVariations.stones ||
            item.description.possibleVariations.jewelleryStone.normal ||
            item.description.possibleVariations.jewelleryStone.model
          "
          @click="configure('stones')"
        >
          <div class="col-10">
            <h5>{{ $t("Set.Item.Description.stones.title") }}</h5>
            <p v-if="item.description.stones.text !== ''">
              <span v-html="item.description.stones.text"></span>
            </p>
            <div
              class="stone-addons"
              v-if="item.description.stones.text !== '' && isStoneAddon"
            >
              <span class="stone-addons-title"
                >{{ $t("Menu.list.stones.group.addon.title") }}:</span
              >
              <ul
                style="list-style: none; padding: 0"
                v-for="(group, index) in item.description.stones.groups"
                v-bind:key="'group_addon_' + index"
              >
                <li
                  v-for="(addon, key) in group.addons"
                  v-bind:key="'addon_' + key"
                >
                  {{ setAddonText(addon.text) }}
                </li>
              </ul>
            </div>
            <div
              class="stone-setting"
              v-if="
                item.description.stones.text !== '' &&
                item.description.stones.groups[0]['setting'] !== ''
              "
            >
              <span class="stone-setting-title"
                >{{ $t("Menu.var.jewellery.setting") }}:</span
              >
              <ul style="list-style: none; padding: 0">
                <li
                  v-for="(group, index) in item.description.stones.groups"
                  v-bind:key="'group_setting_' + index"
                >
                  {{ setStoneSettingText(group["setting"]) }}
                </li>
              </ul>
            </div>
            <p v-if="item.description.stones.text == ''">
              {{ $t("Set.Item.Description.stones.noStones") }}
            </p>
          </div>
          <div class="col-2 text-end">
            <img :src="appUrl + '/img/icons/edit.svg'" class="icon" />
          </div>
        </div>
        <div
          class="row"
          v-if="
            item.description.stones.diamondStock != false &&
            isCurrentItemDiamond
          "
        >
          <div class="col-12">
            <div class="panel panel-default selected-stone">
              <div class="panel-heading stone-headline">
                {{ $t("Menu.list.diamondStock.selectedStone.title") }}
              </div>
              <div class="panel-body stone-body">
                {{ item.description.stones.diamondStock.description }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-4 btn-col" v-if="isCurrentItemDiamond === false">
            <a @click="cloneItem(item.itemnumber)" class="btn btn-link">
              {{ $t("Set.Item.Description.clone") }}
            </a>
          </div>
          <div
            class="btn-col"
            :class="{
              'col-4': !isCurrentItemDiamond,
              'col-12': isCurrentItemDiamond,
            }"
          >
            <a @click="replaceItem" class="btn btn-link">{{
              $t("Set.AddItem.addForm.replaceItem")
            }}</a>
          </div>
          <div
            class="btn-col"
            :class="{
              'col-4': !isCurrentItemDiamond,
              'col-12': isCurrentItemDiamond,
            }"
          >
            <a @click="dropItem(index)" class="btn btn-link">{{
              $t("Set.Item.Description.delete")
            }}</a>
          </div>
        </div>
        <div
          class="row campaign-disclaimer text-center"
          v-if="isCampaignWeddingRings && !isDesktop"
        >
          <div class="col-12">
            <small>* {{ $t("Set.Overview.campaign.disclaimer") }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SetData from "@/vuex/SetData";
import Config from "@/vuex/Config";
import Notification from "@/assets/Helper/Notification";
import Engraving from "@/vuex/Engraving";
import MenuList from "@/assets/Helper/MenuList";
import CopyIcon from "@/components/Icons/Copy";
import MediaQuery from "@/assets/Helper/MediaQuery";

export default {
  name: "SetItemDescription",
  data() {
    return {
      appUrl: Config.getters.getAppUrl,
      campaigns:
        typeof window.conf2020AppConfig.campaigns === "object"
          ? window.conf2020AppConfig.campaigns
          : { weddingbands: "no", jewellery: "no", priceDrop: "no" },
      minSize: 42,
      maxSize: 78,
      stoneSettingText: {},
      addonText: {},
    };
  },
  components: {
    CopyIcon,
  },
  props: ["currentItem", "items"],
  mounted() {
    if (
      this.$parent.currentNavigation === "overview" ||
      this.$parent.currentNavigation === "warehouse"
    ) {
      this.$root.$emit("setOverview");
    }
    this.pushPageImpression();
  },
  watch: {
    currentItem: {
      handler: function () {
        this.pushPageImpression();
      },
      deep: true,
    },
  },
  methods: {
    setAddonText: function (addonText) {
      addonText = addonText.toString().trim();
      if (!this.addonText[addonText]) {
        this.addonText[addonText] = true;
      } else {
        addonText = "";
      }
      return addonText;
    },
    setStoneSettingText: function (stoneSettingText) {
      stoneSettingText = stoneSettingText.trim();
      if (!this.stoneSettingText[stoneSettingText]) {
        this.stoneSettingText[stoneSettingText] = true;
      } else {
        stoneSettingText = "";
      }
      return stoneSettingText;
    },
    pushPageImpression: function () {
      if (
        this.currentItem !== "overview" &&
        this.currentItem !== "all" &&
        this.currentItem !== "set"
      ) {
        this.$ga.page("/item/" + (this.currentItem + 1) + "/overview");
      }
    },
    changeItemName: function (name) {
      SetData.dispatch("setNameOfItem", name);
    },
    configure: function (type) {
      this.$root.$emit("unsetOverview");
      this.$root.$emit("unsetNameAndSize");

      this.items[this.currentItem].description.possibleVariations =
        MenuList.translateKeys(
          this.items[this.currentItem].description.possibleVariations
        );

      if (type === "stones") {
        if (
          this.items[this.currentItem].description.possibleVariations.stones ===
          false
        ) {
          type = this.items[this.currentItem].description.possibleVariations
            .jewelleryStone.normal
            ? "stones/jewellery/normal"
            : "stones/jewellery/model";
        }
      }

      if (this.items[this.currentItem].description.possibleVariations[type]) {
        Config.dispatch("setCurrentVarType", type).then(() =>
          this.$root.$emit("hideLoader3D")
        );
      }
    },
    dropItem: function (itemKey) {
      Config.dispatch("setVisualMode", "show").then(() => {
        Config.dispatch("setCurrentVarType", "");
      });

      SetData.dispatch("dropItem", itemKey);

      this.$parent.$parent["reset3d"]();
      this.$parent.$parent["setCurrentItem"]("overview");
      setTimeout(() => {
        this.$root.$emit("updateViewer");
      }, 750);
    },
    replaceItem: function () {
      this.$parent.$parent["setCurrentItem"]("all");
    },
    cloneItem: function (itemnumber) {
      SetData.dispatch("addItem", itemnumber);

      this.$parent.$parent["reset3d"]();
      this.$parent.$parent["setCurrentItem"]("overview");
      setTimeout(() => {
        this.$root.$emit("updateViewer");
      }, 750);
    },
    changeItemSize: function (event) {
      if (
        isNaN(event.target.value) ||
        event.target.value < this.minSize ||
        event.target.value > this.maxSize
      ) {
        Notification.create(
          this.$t("Set.Item.Description.size.wrong.alert.title"),
          this.$t("Set.Item.Description.size.wrong.alert.text")
        );
        return false;
      }
      this.$parent.$parent["reset3d"](true);

      if (
        event.target.value > this.overSize &&
        event.target.value >= this.minSize &&
        event.target.value <= this.maxSize
      ) {
        Notification.create(
          this.$t("Set.Item.Description.size.oversize.alert.title"),
          this.$t("Set.Item.Description.size.oversize.alert.text")
        );
      }

      let size = event.target.value;

      let stepFactor =
        this.items[this.currentItem].description &&
        this.items[this.currentItem].description.jewelleryType != 0
          ? 1
          : 2;

      size = Math.round(size * stepFactor) / stepFactor;

      this.items[this.currentItem].size = size;

      SetData.dispatch("setItemSize", size);
    },
    getEngravingText: function (fontId) {
      return Engraving.getters.getFontTextById(fontId);
    },
  },
  computed: {
    isStoneAddon: function () {
      for (let i in this.items[this.currentItem].description.stones.groups) {
        if (
          this.items[this.currentItem].description.stones.groups[i].addons &&
          this.items[this.currentItem].description.stones.groups[i].addons[0]
        ) {
          return true;
        }
      }
      return false;
    },
    isCurrentItemDiamond: function () {
      return this.$parent["isCurrentItemDiamond"](this.currentItem);
    },
    overSize: function () {
      let oversize = SetData.getters.getOverSize;
      if (
        this.items[this.currentItem].description &&
        this.items[this.currentItem].description.jewelleryType != 0
      ) {
        return oversize.jewelleryring;
      } else {
        return oversize.weddingring;
      }
    },
    sizeStep: function () {
      return this.items[this.currentItem].description &&
        this.items[this.currentItem].description.jewelleryType != 0
        ? 1
        : 0.5;
    },
    isCampaignWeddingRings: function () {
      if (
        this.campaigns.weddingbands === "yes" &&
        this.$parent.isCurrentItemWeddingRing()
      ) {
        return true;
      }
      return false;
    },
    isDesktop: function () {
      return MediaQuery.isDesktop();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.price,
.itemnumber {
  font-size: 1em;
  line-height: 1.6em;
  border-bottom: solid 0.05em $borderColor;
  padding-top: 2rem;
  padding-bottom: 1em;
}

.itemnumber {
  padding-bottom: 0.5em;
}

.item-description {
  background-color: $white;
  padding: 0 1.5rem;
}

#app {
  h5 {
    margin-bottom: 0.5rem;
  }

  ul {
    padding-left: 1.5rem;
    margin: 0;

    li {
      margin-bottom: 0.5rem;
    }
  }

  .campaign-info {
    padding-top: 0.5rem;
    color: $pink;
    font-weight: bold;
  }

  .campaign-disclaimer {
    small {
      display: inline-block;
      margin-top: 2rem;
    }
  }

  .btn-col {
    padding-left: 0rem;

    &.col-12 {
      padding: 0 0 1rem 0;
    }

    @media (max-width: 374px) {
      &.col-4 {
        width: 100%;
        padding: 0 0 1rem 0;
      }
    }
  }
}

div.stone-addons,
div.stone-setting {
  margin-top: 2rem;
}

.selected-stone {
  margin-top: 1rem;
  margin-bottom: 1rem;
  background-color: #ffffff;

  .stone-headline {
    font-weight: bold;
  }
}

.desc {
  font-size: 1em;

  .row {
    cursor: pointer;
    padding-top: 1em;
    padding-bottom: 1em;
    border-bottom: solid 0.05em $borderColor;
  }

  .row:last-child {
    border: none;
  }
}

.price-original {
  margin-right: 1rem;
  text-decoration: line-through;
}

.price-discount {
  color: $pink;
}

.text-end {
  display: flex;
  justify-content: flex-end;
}
</style>
